const extractTitle = (fileName: string): string => {
  return fileName.replace(/\.[^/.]+$/, '');
};

export default extractTitle;
